import React from 'react';
import { Space } from 'antd';

import Logo from 'components/layouts/Logo';
import UserMenu from './components/UserMenu/UserMenu';
import LanguageSelect from './components/LanguageSelect/LanguageSelect';
import ThemeSwitcher from 'components/switchers/ThemeSwitcher/ThemeSwitcher';

import { IHeaderProps } from './Header.types';

import './Header.styles.scss';

const Header = ({ showLogo, className = '', ...props }: IHeaderProps) => {
  return (
    <div className={`np-header ${className}`} {...props}>
      <div className="np-header__body">
        {showLogo ? <Logo /> : <div />}

        <Space align="center" size={24}>
          <LanguageSelect />
          <ThemeSwitcher />
          <UserMenu />
        </Space>
      </div>
    </div>
  );
};

export default Header;
